<template>
  <notifications
    position="top right"
    class="notification-toast"
    :duration="5000"
  >
    <template slot="body" slot-scope="props">
      <div class="custom-template" :class="props.item.type">
        <div class="custom-template-icon" :class="props.item.type">
          <b-icon-check-circle
            v-if="props.item.type === 'success'"
            class="icon"
          />
          <b-icon-exclamation-circle
            v-if="props.item.type === 'error'"
            class="icon"
          />
          <b-icon-exclamation-triangle
            v-if="props.item.type === 'warn'"
            class="icon"
          />
        </div>
        <div class="custom-template-content">
          <div class="custom-template-title">
            {{ props.item.title }}
          </div>
          <div v-if="props.item.text" class="custom-template-subtitle">
            {{ props.item.text }}
          </div>
        </div>
        <div
          class="custom-template-close"
          :class="props.item.type"
          @click="props.close"
        >
          <b-icon-x scale="1.5" />
        </div>
      </div>
    </template>
  </notifications>
</template>
<script>
import {
  BIconCheckCircle,
  BIconExclamationCircle,
  BIconExclamationTriangle,
  BIconX
} from 'bootstrap-vue'

export default {
  name: 'App',
  components: {
    BIconCheckCircle,
    BIconExclamationCircle,
    BIconExclamationTriangle,
    BIconX
  }
}
</script>
<style lang="scss" scoped>
.notification-toast {
  z-index: 2147483001;
  width: 450px !important;
  top: 80px !important;
  @media screen and (max-width: 1023px) {
    width: 320px !important;
  }
  @media screen and (max-width: 576px) {
    width: 300px !important;
  }
}
.custom-template {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  text-align: left;
  font-size: 13px;
  margin: 5px;
  padding: 16px;
  margin-bottom: 0;
  align-items: center;
  justify-content: flex-start;
  border-radius: 8px;
  &,
  & > div {
    box-sizing: border-box;
  }
  &.success {
    background: $spring-green-100;
    border: 2px solid $spring-green-600;
  }
  &.error {
    background: #f9eae9;
    border: 2px solid #e8c6c4;
  }
  &.warn {
    background: $mustard-yellow-50;
    border: 2px solid $mustard-yellow-500;
  }
  .custom-template-icon {
    border: 2px solid transparent;
    border-radius: 50px;
    min-width: 24px;
    width: 24px;
    height: 24px;
    margin: 0px 5px;
    display: flex;
    align-items: center;
    justify-items: center;
    .icon {
      margin: auto;
      width: 12px;
      height: 12px;
    }
    &.success {
      color: $spring-green-600;
      border-color: $spring-green-600;
    }
    &.error {
      color: $danger;
      border-color: $danger;
    }
    &.warn {
      color: $mustard-yellow-500;
      border-color: $mustard-yellow-500;
    }
  }
  .custom-template-close {
    padding: 0px 8px;
    font-size: 16px;
    opacity: 1;
    cursor: pointer;
    align-self: flex-start;
    &.success {
      color: $spring-green-600;
    }
    &.error {
      color: $danger;
    }
    &.warn {
      color: $mustard-yellow-500;
    }
  }
  .custom-template-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0px 10px;
    flex: 1;
    .custom-template-title {
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 19px;
      display: flex;
      align-items: center;
    }
    .custom-template-subtitle {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
    }
  }
}
</style>
